import { useEffect, useState } from "react";
import { getUnreadCount } from "@/api/news";
import { useAuth } from "@/auth/useAuth";

export function useNewsUnread(): number {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) return;
    if (user.roles.length === 1 && user.roles[0] === "cliente") return;
    let cancelled = false;
    async function tick() {
      try {
        const u = await getUnreadCount();
        if (!cancelled) setUnread(u);
      } catch {
        /* silent */
      }
    }
    tick();
    const id = setInterval(tick, 60_000);
    const onFocus = () => tick();
    window.addEventListener("focus", onFocus);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, [user]);

  return unread;
}
